import React from 'react';
// import moment from 'moment';
import dateLib from '@/utils/dateLib/moment';
import { MOMENT_LANG } from '@/utils/locale';
import './index.scss';
interface AgentTimeProps {
  time?: number;
}

export default class AgentTime extends React.PureComponent<AgentTimeProps> {
  render() {
    const { time } = this.props;

    // let nowTime = moment(time).format('MMM DD, hh:mm A');
    let nowTime = dateLib.format(this.props.time, 'MMM DD, hh:ii A');
    if (MOMENT_LANG === 'en') {
      nowTime = nowTime.toUpperCase();
    }

    return (
      <div className="agent-time-wrapper">
        <div className="agent-time">{nowTime}</div>
      </div>
    );
  }
}
